import React from "react";
import { useTheme } from "../../Context/ThemeContext";
import { getThemeLogo } from "../../Common/Data";
import "./ThemeLogo.css";

export default function ThemeLogo({
  className = "",
  alt = "AETHRX",
  width,
  height,
  ...imgProps
}) {
  const { resolvedTheme } = useTheme();
  const src = getThemeLogo(resolvedTheme);

  return (
    <img
      src={src}
      alt={alt}
      className={`theme-logo ${className}`.trim()}
      width={width}
      height={height}
      {...imgProps}
    />
  );
}
